import React, { useEffect } from 'react';
import { ProviderParams } from '../models/react';
import { ProcessingContextType, ProcessingObject } from '../models/processing';
import useSessionStorage from '../hooks/sessionStorage.hook';

const ProcessingContext = React.createContext<ProcessingContextType | undefined>(undefined);
export function useProcessingContext() {
    return React.useContext(ProcessingContext);
}

export default function ProcessingProvider({ children }: ProviderParams) {
    const [isBusy, setIsBusy] = React.useState(false);
    const [isFrozen, setIsFrozen] = React.useState(false);
    const [notification, setNotification] = React.useState({message: ''});
    const [started, setStarted] = React.useState(false)
    const processingStorage = useSessionStorage("processing") 

    useEffect(()=>{
            if(started) {
                let processingObject:ProcessingObject = {
                    isBusy: isBusy,
                    isFrozen: isFrozen,
                    notification: notification
                }
                processingStorage.setValue(JSON.stringify(processingObject))
            }
    }, [isBusy, isFrozen, notification])

    useEffect(()=>{
        const processed = recoverLanguageFromStorage()
        setIsBusy(processed.isBusy)
        setIsFrozen(processed.isFrozen)
        setNotification(processed.notification)
        setStarted(true)
    }, [])


    function recoverLanguageFromStorage (): ProcessingObject {
        let processingObject:ProcessingObject  = {
            isBusy:false,
            isFrozen:false, 
            notification: {
                message: ''
            }
        }
        if (processingStorage.value && processingStorage.value!=="") {
            try{
                const stored = JSON.parse(processingStorage.value) as ProcessingObject
                processingObject = stored;

            }catch(err:any){
                console.debug("Error during parse processing context values from session storage")
            }
        }
        return processingObject
    }
    return (
        <ProcessingContext.Provider value={ { isBusy, setIsBusy, isFrozen, setIsFrozen, notification, setNotification } }>
            { children }
        </ProcessingContext.Provider>
    );
}
